import React from 'react';
import { Button, Tooltip } from '@myua/kit';
import { Link21 } from '@myua/icons/dist/bulk16';
import * as sharingActions from '../actions';
import { useSelector, useDispatch } from 'react-redux';
import { getCanCreateSharingLink, getShareInProgress } from '../selectors';
import { getData } from '../../pack/selectors';
import { ShareContext } from '../model';
import { getAssetLabLogger } from '../../app/logs';
import { DEMO_UNAVAILABLE_TOOLTIP } from '../../../../general/model';

export const SharePackButton = () => {
  const dispatch = useDispatch();
  const inProgress = useSelector(getShareInProgress)[ShareContext.pack];
  const { total } = useSelector(getData);
  const assetLabLogger = useSelector(getAssetLabLogger);

  const canShare = useSelector(getCanCreateSharingLink);

  const button = (
    <Button
      className="al-btn-blue-icon"
      loading={canShare && inProgress}
      disabled={!canShare || total.read.count === 0}
      icon={<Link21 />}
      onClick={() => {
        dispatch(sharingActions.sharePackClicked());
        assetLabLogger({ action: 'Pack', sub_action: 'Share' });
      }}
    >
      Save
    </Button>
  );

  return canShare ? button : <Tooltip title={DEMO_UNAVAILABLE_TOOLTIP}>{button}</Tooltip>;
};
